module.exports = __webpack_public_path__ + "img/1480679439.d94d88fe.jpg";